const ContactListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 250
  },
  {
    title: 'Description',
    dataIndex: 'description',
    width: 250
  },
  {
    title: 'Contact Group',
    dataIndex: 'contact_group',
    sorter: (a, b) => a.contact_group.localeCompare(b.contact_group),
    width: 250
  },
  {
    title: 'Email',
    dataIndex: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    width: 250
  },
  {
    title: 'SMS',
    dataIndex: 'sms',
    width: 250
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];

export { ContactListColumn };
